/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetShowProductStockQueryResponse, GetShowProductStockPathParams, GetShowProductStockQueryParams, GetShowProductStock404 } from "../../models/GetShowProductStock";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetShowProductStockUrl({ code }: { code: GetShowProductStockPathParams["code"] }) {
  const res = { method: 'GET', url: `/api/v1/products/${code}/stock` as const }  
  return res
}

/**
 * {@link /api/v1/products/:code/stock}
 */
export async function getShowProductStock({ code, params }: { code: GetShowProductStockPathParams["code"]; params: GetShowProductStockQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetShowProductStockQueryResponse, ResponseErrorConfig<GetShowProductStock404>, unknown>({ method : "GET", url : getGetShowProductStockUrl({ code }).url.toString(), params, ... requestConfig })  
  return res.data
}